import { gql } from '@apollo/client'

const UPDATE_PRIORITY_TASK_MUTATION = gql`
  mutation updatePriorityTaskMutation(
    $id: ID!
    $data: PriorityTaskUpdateInput!
  ) {
    updatePriorityTask(id: $id, data: $data) {
      id
      priority
      isDone
    }
  }
`

export default UPDATE_PRIORITY_TASK_MUTATION
